module.exports = __webpack_public_path__ + "static/media/microscopy-yliv-01 9.d30d39dc.png";